import { InjectionToken } from '@angular/core';
import { environment } from '@environment/environment';

export const externalLinks = {
  socialNetworks: {
    twitter: 'https://twitter.com/renault_esp',
    facebook: 'https://www.facebook.com/renaultespana/',
    instagram: 'https://www.instagram.com/renault_esp/?hl=es',
    linkedin: 'https://www.linkedin.com/company/grouperenaultespana',
    youtube: 'https://www.youtube.com/user/RenaultESP',
  },
  marketplace: {
    google: 'https://play.google.com/store/apps/details?id=es.renaultbank.andr&hl=es',
    apple: 'https://apps.apple.com/es/app/renault-bank/id1523833814',
  },
  home: {
    root: environment.applications.home,
    bulletinBoard: `${environment.applications.home}/atencion-al-cliente`,
    privacyPolicy: `${environment.applications.home}/politica-de-privacidad`,
    legaNote: `${environment.applications.home}/nota-legal`,
    cookies: `${environment.applications.home}/politica-de-cookies`,
    psd2: `${environment.applications.home}/psd2`,
  },
  onboarding: environment.applications.onboarding,
};

export type ExternalLinks = typeof externalLinks;

export const EXTERNAL_LINKS = new InjectionToken<ExternalLinks>('EXTERNAL_LINKS', {
  providedIn: 'root',
  factory: () => externalLinks,
});
